/* eslint-disable no-undef */
/**
 * @fileOverview Configuration and shared flags for API level encryption.
 * @module encryption/config
 */

export const ENC_VERSION = 1;
export const API_PREFIX = "/api/v1";

/** Routes that are always sent / received as plain JSON. */
export const PLAIN_ROUTES = [
  `${API_PREFIX}/general/getSetting`,
  `${API_PREFIX}/encryption/public-key`,
  `${API_PREFIX}/encryption/session`,
];

/** Route prefixes that are always sent / received as plain JSON. */
export const PLAIN_PREFIXES = [`${API_PREFIX}/admin/`];

/** Routes after which the encryption session must be dropped. */
export const LOGOUT_ROUTES = [
  `${API_PREFIX}/auth/logout`,
  `${API_PREFIX}/auth/logoutWithoutAuth`,
];

export const SETTING_ROUTE = `${API_PREFIX}/general/getSetting`;

/** Re-check `is_encryption_enabled` after this long. */
export const FLAG_RECHECK_MS = 5 * 60 * 1000;
/** Retry a failed flag lookup after this long. */
export const FLAG_RETRY_MS = 30 * 1000;
/** After a failed session establishment, fail fast for this long. */
export const SESSION_COOLDOWN_MS = 30 * 1000;
/** Re-establish the session this long before it expires. */
export const SESSION_EXPIRY_SKEW_MS = 60 * 1000;

/**
 * Pinned SHA-256 fingerprints (lowercase hex) of the server public key (SPKI),
 * comma separated in REACT_APP_ENC_PINNED_FINGERPRINTS. Empty = no pinning.
 */
export const PINNED_FINGERPRINTS = (
  process.env.REACT_APP_ENC_PINNED_FINGERPRINTS || ""
)
  .split(",")
  .map((fingerprint) => fingerprint.trim().toLowerCase())
  .filter(Boolean);

export const isDev = process.env.NODE_ENV !== "production";

/** Runtime state shared by the encryption layer. */
export const encState = {
  enabled: false,
  forcedOn: false,
  checkedAt: 0,
  clockOffsetMs: 0,
};

export const parseFlag = (value) => value === true || value === "true";

export const isPlainPath = (path) =>
  PLAIN_ROUTES.includes(path) ||
  PLAIN_PREFIXES.some((prefix) => path.startsWith(prefix));

/** Dev only logging, never pass keys through here. */
export const encLog = (...args) => {
  if (isDev) console.log("[enc]", ...args);
};
